module.exports = __webpack_public_path__ + "img/banner-2-1@1x.5ac986a7.jpg";